import { makeStyles } from '@material-ui/core';

import { Tag, TagGroup } from '@backstage/ui';

import { extractLastNameComponent } from '@spotify/confidence-core-react';
import { useIdentity } from '@spotify/plugin-confidence-iam-react';

const useStyles = makeStyles({
  container: {
    alignItems: 'center',
    display: 'flex',
    flexWrap: 'wrap',
    gap: 'var(--bui-space-2)',
    paddingBottom: 'var(--bui-space-1)',
  },
  oldValue: {
    opacity: 0.6,
    textDecoration: 'line-through',
  },
});

export interface ActivityUserItemProps {
  oldValue?: string;
  newValue?: string;
  ariaLabel?: string;
}

const useDisplayName = (identityName: string | undefined): string => {
  const { identity } = useIdentity({
    name: identityName ?? '',
    skip: !identityName,
  });
  return (
    identity?.displayName ?? extractLastNameComponent(identityName ?? '') ?? ''
  );
};

export const ActivityUserItem = ({
  oldValue,
  newValue,
  ariaLabel,
}: ActivityUserItemProps) => {
  const classes = useStyles();
  const oldDisplayName = useDisplayName(oldValue);
  const newDisplayName = useDisplayName(newValue);

  return (
    <div className={classes.container}>
      {oldValue && (
        <span className={classes.oldValue}>
          <TagGroup aria-label={ariaLabel ?? 'Previous owner'}>
            <Tag size="medium" textValue={`@${oldDisplayName}`}>
              @{oldDisplayName}
            </Tag>
          </TagGroup>
        </span>
      )}
      {newValue && (
        <TagGroup aria-label={ariaLabel ?? 'New owner'}>
          <Tag size="medium" textValue={`@${newDisplayName}`}>
            @{newDisplayName}
          </Tag>
        </TagGroup>
      )}
    </div>
  );
};
